import { del } from "storefront/GrailedAPI/request";

type Response = void;

const destroy = (): Promise<Response> => del<Response>("/api/sign_out");

export default destroy;
